module.exports = __webpack_public_path__ + "static/team-4-7633b123a95b2884da7e88634835d147.jpg";